import React from "react";
import { Roles } from "../../../../auth/rolesPermissions";
import { Languages } from "../../../../components/languages";
import { emailValidation, emptyValidation, zipValidation,  QuantityValidation} from "../../../../components/validate";
import { FieldProps } from "../../../../components/fieldProps";
import { PageTitle, UIButton, UIButtonPad, UISuccessPopup } from "../../../../components/guiElements";
import { loadRecipientAddressesFromUsername, loadAutocompleteCountries, autoCompleteForeignCitiesForCountry } from "../../../../components/globals";
import { getStockAPI, getDealers, SendOrder } from "../../../../api/warehouseAPI";
import { warehouseUIProfiles } from "../../../../auth/warehouseProfiles";
import { buildStandardHeaders } from "../../WarehouseOrderCreation/config/headers";
import { buildStandardFilters, standardAdvancedFilterNames } from "../../WarehouseOrderCreation/config/filters";
import { validateRecipient, validateOrderInfo, validateSelectedItems, getProductDealerCode, hasMixedDealerCodes } from "../../WarehouseOrderCreation/validation/standard-dealer";
import * as standardOrderLogic from "../../WarehouseOrderCreation/logic/OrderCodes";
import { buildOrderPayload } from "../../WarehouseOrderCreation/logic/OrderPayload";
import { WarehouseOrderInfo, WarehouseFilters, WarehouseStockSelection, WarehouseOrderOptions, WarehouseAddresses } from "../../Components/warehouseComponents";
//export class WarehouseSingleOrderCreation extends React.Component {
export class StandardDealerSingleOrderCreation extends React.Component {
    //#region Constructor
    constructor(props) {
        super(props);
        this.location = props.location;
       // this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.uc = props.userContext;
        this.le = Languages.Warehouse.SingleOrderCreation[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.validate_le = Languages.Validate[Languages.selectedLanguage];
        this._isMounted = false;
        this._stockRequestVersion = 0;

        this.uiProfile = warehouseUIProfiles[this.uc?.userRole] || warehouseUIProfiles.DEFAULT;

        //this.profile = resolveProfile("standard-dealer");
        this.profile = props.profile;
        this.orderLogic = { ...standardOrderLogic };

        this.addressChange = this.addressChange.bind(this);
        this.onRecipientCountryChange = this.onRecipientCountryChange.bind(this);
        this.onRecipientCityChange = this.onRecipientCityChange.bind(this);
        this.onRecipientCitySelected = this.onRecipientCitySelected.bind(this);
        this.handleFilterSearch = this.handleFilterSearch.bind(this);
        this.getDataStock = this.getDataStock.bind(this);
        this.buildEntriesStock = this.buildEntriesStock.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.handleSelectionChange = this.handleSelectionChange.bind(this);
        this.validateSelectedItems = this.validateSelectedItems.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getDealersData = this.getDealersData.bind(this);
        this.buildEntriesDealer = this.buildEntriesDealer.bind(this);
        this.setRecipientFromDealer = this.setRecipientFromDealer.bind(this);
        this.handleOrderInfoChange = this.handleOrderInfoChange.bind(this);


        this.configs = {
            filters: this.getFiltersConfig(),
        };

        this.header = this.getStockHeaders();

        this.inputBoxes = this.getInputBoxes();

        const filters = this.createInitialFilters();

        this.appliedFilters = filters;

        //#region state

        this.state = {
            senderWarehouses: [],
            selectedWarehouseId: "",
            warehouseConfigReady: false,
            warehouseConfigError: "",
            countries: [],
            recipientCountryCode: "",
            suggestedRecipientCities: [],
            sender: {},
            recipient: {},
            carriers: [],
            data: {
                orderInfo: {
                    orderReference: "",
                    notes: ""
                },
                sender: {},
                recipient: {
                    selectedDealer: "",
                    recipientSource: "manual",
                    recipientSourceId: "",

                    name: "",
                    surname: "",
                    recipientCode: "",
                    country: "ITALIA",
                    province: "",
                    city: "",
                    zip: "",
                    address: "",
                    email: "",
                    mobile: ""
                },
                sendLabel: this.uc.userRole === Roles.WAREHOUSEADMIN
                    ? true
                    : false,
            },
            entries: [],
            dealers: [],
            recipientWarehouses: [],
            recipientOptions: [],
            filters: filters,
            products: [],
            orderType: this.le.orderTypes.value[0],
            customerPickup: false,
            totals: [],
            selectedProducts: [],
            tableInstanceId: 0,
            showSuccessPopup: false,
            successOrderNumber: "",
            advancedOpen: false,
            errors: {
                global: [],
                quantity: {},
                recipient: {},
                orderInfo: {}
            },

            pageNumber: 1,
            pageSize: 10,
            sortField: "SKU",
            sortDirection: "asc",
            totalItems: 0,
            totalPages: 0
        };
        //#endregion

        this.orderInfoConfig = {
            title: this.le.orderInfo.title,
            referenceLabel: this.le.orderInfo.referenceOrder,
            referencePlaceholder: "",
            referenceMaxLength: 100,
            referenceMandatory: true,
            referenceHint: this.le.orderInfo.notAllowedCharacters,

            notesLabel: this.le.orderInfo.notes,
            notesPlaceholder: "",
            notesRows: 5,
            notesMaxLength: 1000,
            notesMandatory: false
        }

        this.baseOrderInfoConfig = { ...this.orderInfoConfig };
    }
    // #endregion

    //#region Single Order Creations Functions

    //#region config

    getStockHeaders() {
        return this.profile.customizeHeaders(
            buildStandardHeaders(this.le, this.uiProfile)
        );
    }

    getFiltersConfig() {
        return this.profile.customizeFilters(
            buildStandardFilters(this.uiProfile)
        );
    }

    //#endregion

    //#region Warehouse config

    loadWarehouseConfiguration = async () => {
        const configuration = this.props.configuration;

        if (!this._isMounted) {
            return false;
        }

        const warehouses = configuration.warehouses;

        if (!Array.isArray(warehouses)) {
            throw new Error(
                "Configurazione magazzini non valida."
            );
        }

        //this.profile = resolveProfile(
        //    configuration.profileCode
        //);

        this.orderLogic = {
            ...standardOrderLogic,
            ...this.profile.orderLogic
        };

        this.configs = {
            filters: this.getFiltersConfig()
        };

        this.header = this.getStockHeaders();

        this.orderInfoConfig =
            this.profile.customizeOrderInfoConfig({
                ...this.baseOrderInfoConfig
            });

        const defaultWarehouse =
            warehouses.find(warehouse => warehouse.isDefault);

        const selectedWarehouseId =
            warehouses.length === 1
                ? warehouses[0].id
                : defaultWarehouse?.id || "";

        const initialFilters = this.createInitialFilters();
        this.appliedFilters = initialFilters;

        await new Promise(resolve => {
            this.setState({
                senderWarehouses: warehouses,
                selectedWarehouseId,
                filters: initialFilters,
                warehouseConfigReady: true,
                warehouseConfigError: ""
            }, resolve);
        });

        return true;
    };

    //#endregion

    //#region logic

    normalizeOrderCodes = product => {
        return this.orderLogic.normalizeOrderCodes(product);
    };

    buildOrderNumber = (orderReference, dealerCode) => {
        return this.orderLogic.buildOrderNumber(orderReference, dealerCode, this.uc.userRole);
    };

    formatReturnedOrderNumber = orderNumber => {
        return this.orderLogic.formatReturnedOrderNumber(orderNumber, this.uc);
    };

    //#endregion

    //#region Configuration Builders

    getInputBoxes() {
        return [
            {
                id: 'input',
                title: '',
                class: '',
                columns: [
                    {
                        id: 'sender',
                        title: { rowClass: '', colClass: '', value: this.le.sender.title },
                        rowsize: 100,
                        itemunit: 30,
                        items: this.getSenderItems()
                    },
                    {
                        id: 'recipient',
                        title: { rowClass: '', colClass: '', value: this.le.recipient.title },
                        rowsize: 100,
                        itemunit: 30,
                        items: this.getRecipientItems()
                    }
                ]
            }
        ]
    }

    //#region Sender config

    getSenderItems() {
        return [
            {
                id: "warehouse",
                size: 100,
                text: this.le.sender.inputs[0],
                type: "text",
                mandatory: true,
                options: [],
                disabled: true,
                value: ""
            },
            {
                id: "city",
                mandatory: true,
                size: 100,
                text: this.le.sender.inputs[1],
                type: "text",
                disabled: true,
                value: ""
            },
            {
                id: "province",
                mandatory: true,
                size: 70,
                width: "70%",
                text: this.le.sender.inputs[2],
                type: "text",
                disabled: true,
                value: ""
            },
            {
                id: "country",
                mandatory: true,
                size: 100,
                text: this.le.sender.inputs[3],
                type: "text",
                disabled: true,
                value: ""
            }
        ];
    }

    getSelectedWarehouse = () => {
        return this.state.senderWarehouses.find(
            warehouse =>
                warehouse.id === this.state.selectedWarehouseId
        ) || null;
    };

    handleWarehouseChange = value => {
        const warehouse =
            value === "" || value === null || value === undefined
                ? null
                : this.state.senderWarehouses.find(
                    item => item.id === Number(value)
                );

        this.setState({
            selectedWarehouseId: warehouse?.id ?? ""
        });
    };

    //#endregion

    getRecipientItems() {

        return [
            {
                id: 'selectedDealer',
                size: 100,
                text: this.le.recipient.inputs[0],
                type: this.uiProfile.showDealerSelect ? 'select' : 'text',
                options: this.uiProfile.showDealerSelect ? [{ text: '---------', value: '' }]
                    : [],
                disabled: false,
                value: ''
            },
            {
                id: "name",
                mandatory: true,
                manualOnly: true,
                size: 100,
                text: this.le.recipient.inputs[1],
                type: "text",
                source: "recipient",
                options: [],
                validate: emptyValidation,
                disabled: true,
                value: ""
            },
            {
                id: "recipientCode",
                mandatory: true,
                size: 100,
                text: this.le.recipient.inputs[2],
                source: "recipient",
                type: "hidden",
                options: [],
                validate: emptyValidation,
                disabled: true,
                value: ""
            },
            {
                id: "country",
                mandatory: true,
                size: 100,
                text: this.le.recipient.inputs[3],
                maxLength: FieldProps.getFieldProp("country", "maxLength"),
                source: "recipient",
                type: "selectField",
                options: [],
                validate: emptyValidation,
                disabled: true,
                value: "ITALIA"
            },
            {
                id: "city",
                mandatory: true,
                size: 100,
                text: this.le.recipient.inputs[5],
                maxLength: FieldProps.getFieldProp("city", "maxLength"),
                disabled: true,
                type: "autocomplete",
                options: [],
                validate: emptyValidation,
                value: ""
            },
            {
                id: 'province',
                mandatory: true,
                size: 100,
                text: this.le.recipient.inputs[4],
                maxLength: FieldProps.getFieldProp('province', 'maxLength'),
                disabled: true,
                type: 'text',
                options: [],
                validate: emptyValidation,
                value: ''
            },
            {
                id: 'zip',
                mandatory: true,
                size: 30,
                width: '28%',
                text: this.le.recipient.inputs[6],
                disabled: true,
                type: 'text',
                validate: zipValidation,
                value: ''

            },
            {
                id: 'address',
                mandatory: true,
                size: 70,
                width: '70%',
                text: this.le.recipient.inputs[7],
                maxLength: FieldProps.getFieldProp('address', 'maxLength'),
                type: 'text',
                validate: emptyValidation,
                disabled: true,
                value: ''
            },
            {
                id: 'email',
                mandatory: true,
                validate: emailValidation,
                size: 100,
                text: this.le.recipient.inputs[8],
                maxLength: FieldProps.getFieldProp('email', 'maxLength'),
                type: 'text',
                disabled: true,
                value: ''
            },
            {
                id: 'mobile',
                mandatory: true,
                validate: emptyValidation,
                size: 100,
                text: this.le.recipient.inputs[9],
                // maxLength: FieldProps.getFieldProp('email', 'maxLength'),
                type: 'text',
                disabled: true,
                value: ''
            }
        ]
    }

    buildRecipientOptions = (dealers = [], addresses = []) => [
        {
            text:
                this.le.recipient.manualOption ||
                "Inserimento manuale",
            value: ""
        },

        ...dealers.map(dealer => ({
            text: `${dealer.dealerCode}`,
            value: `dealer:${dealer.dealerCode}`
        })),

        ...addresses.map(address => ({
            text: `${address.identifier}`,
            value: `address:${address.id}`
        }))
    ];

    loadRecipientAddressesData = () => {
        loadRecipientAddressesFromUsername(
            this.uc.jwtToken,
            addresses => {
                if (!this._isMounted) {
                    return;
                }

                const recipientWarehouses = addresses || [];

                this.setState(prevState => ({
                    recipientWarehouses,
                    recipientOptions: this.buildRecipientOptions(
                        prevState.dealers,
                        recipientWarehouses
                    )
                }));
            },
            error => {
                console.error("Error when it try to load recipient addresses", error);

                if (!this._isMounted) {
                    return;
                }

                this.setState(prevState => ({
                    recipientWarehouses: [],
                    recipientOptions: this.buildRecipientOptions(
                        prevState.dealers,
                        []
                    )
                }));
            },
            this
        );
    };
   
    createInitialFilters() {
        const filters = {};

        Object.keys(this.configs.filters).forEach(key => {
            if (key === "QuantityFilter") {
                filters[key] = {
                    Comparison: "",
                    Value: ""
                };
            } else {
                filters[key] = this.configs.filters[key].type == "checkbox" ? false : "";
            }
        });

        return filters;
    }

    //#endregion

    //#region Handle Change Functions

    isManualRecipient = (recipient = {}) => {
        return (
            !recipient.selectedDealer ||
            recipient.recipientSource === "manual"
        );
    };

    isRecipientItemDisabled = (item, recipient = {}) => {

        if (item.id === "selectedDealer") {
            return false;
        }

        if (item.id === "recipientCode") {
            return true;
        }

        if (item.id === "province" || item.id === "zip") {
            return true;
        }

        if (!this.isManualRecipient(recipient)) {
            return true;
        }

        return false;
    };

    canUseCustomerPickup = orderType => {
        const config =  this.profile.orderCreation.components.orderOptions;

        return (
            config.enabled === true &&
            config.props.showCustomerPickup === true &&
            orderType === "STD"
        );
    };

    handleRadioChange = value => {
        this.setState(prevState => ({
            orderType: value,

            customerPickup: this.canUseCustomerPickup(value)
                    ? prevState.customerPickup
                    : false
        }));
    };

    handleCustomerPickupChange = e => {
        const checked = e.target.checked;

        this.setState(prevState => ({
            customerPickup: this.canUseCustomerPickup(prevState.orderType) && checked
        }));
    };

    handleSelectionChange = (selectedProducts) => {
        let shouldReloadStock = false;

        this.setState((prevState) => {
            const nextQuantityErrors = {
                ...prevState.errors.quantity
            };

            const selectedIds = new Set(selectedProducts.map(product => product.id));

            Object.keys(nextQuantityErrors).forEach(id => {
                if (!selectedIds.has(id)) {
                    delete nextQuantityErrors[id];
                }
            });

            selectedProducts.forEach(product => {
                const { error } = QuantityValidation(
                    product.SKU,
                    product.quantity,
                    product.avaibleQuantity
                );

                if (error) {
                    nextQuantityErrors[product.id] = error;
                } else {
                    delete nextQuantityErrors[product.id];
                }
            });

            const globalErrors = [];

            if (this.hasMixedDealerCodes(selectedProducts)) {
                globalErrors.push(this.le.errors.differentDealerCode);
            }

            const hadSelectedProducts = prevState.selectedProducts.length > 0;
            const hasSelectedProducts = selectedProducts.length > 0;
            const firstProductSelected = !hadSelectedProducts && hasSelectedProducts;
            const lastProductDeselected = hadSelectedProducts && !hasSelectedProducts;
            shouldReloadStock = firstProductSelected || lastProductDeselected;
            let nextDealerCode = prevState.filters.dealerCode;

            if (firstProductSelected) {
                nextDealerCode = this.getProductDealerCode(selectedProducts[0]);
            }

            if (lastProductDeselected) {
                nextDealerCode = "";
            }

            return {
                selectedProducts,

                filters: {
                    ...prevState.filters,
                    dealerCode: nextDealerCode
                },

                pageNumber: shouldReloadStock
                    ? 1
                    : prevState.pageNumber,

                errors: {
                    ...prevState.errors,
                    global: globalErrors,
                    quantity: nextQuantityErrors
                }
            };
        }, () => {

            if (shouldReloadStock) {
                this.getDataStock(this.state.filters);
            }
        });
    };

    handleOrderInfoChange(ev) {
        const { name, value } = ev.target;

        this.setState(prevState => {
            const orderInfo = {
                ...prevState.data.orderInfo,
                [name]: value
            };

            const validationErrors = this.validateOrderInfo(orderInfo);

            const orderInfoErrors = {
                ...prevState.errors.orderInfo
            };

            delete orderInfoErrors[name];

            if (validationErrors[name]) {
                orderInfoErrors[name] = validationErrors[name];
            }

            return {
                data: {
                    ...prevState.data,
                    orderInfo
                },
                errors: {
                    ...prevState.errors,
                    orderInfo: orderInfoErrors
                }
            };
        });
    }

    updateRecipientData = (newData) => {
        const recipientErrors = this.validateRecipient(newData.recipient);

        this.setState(prevState => ({
            data: newData,
            errors: {
                ...prevState.errors,
                recipient: recipientErrors
            }
        }));
    };

    //#endregion

    //#region Validations Functions

    validateForm = () => {
        const productErrors = this.validateSelectedItems(
            this.state.selectedProducts
        );

        const recipientErrors = this.validateRecipient(
            this.state.data.recipient
        );

        const orderInfoErrors = this.validateOrderInfo(
            this.state.data.orderInfo
        );

        const additionalErrors =
            this.profile.validateAdditional({
                data: this.state.data,
                selectedProducts: this.state.selectedProducts,
                orderType: this.state.orderType,
                userContext: this.uc,
                le: this.le,
                validateLe: this.validate_le
            });

        const global = [
            ...productErrors.global,
            ...additionalErrors.global
        ];

        return {
            global,
            quantity: { ...additionalErrors.quantity, ...productErrors.quantity },
            recipient: { ...additionalErrors.recipient, ...recipientErrors },
            orderInfo: { ...additionalErrors.orderInfo, ...orderInfoErrors }
        };
    };

    validateRecipient = recipient => {
        const isManualRecipient = this.isManualRecipient(recipient);

        const isProvinceRequired = this.profile.isProvinceRequired(recipient);

        const recipientItems =
            this.inputBoxes[0].columns[1].items.map(item =>
                item.id === "province"
                    ? {
                        ...item,
                        mandatory: isProvinceRequired
                    }
                    : item
            );

        return validateRecipient(recipient, { isManualRecipient, recipientItems, validateLe: this.validate_le
        });
    };

    validateOrderInfo = orderInfo => {
        return validateOrderInfo(orderInfo, {
            orderInfoConfig: this.orderInfoConfig,
            validateLe: this.validate_le,
            le: this.le
        });
    };

    validateSelectedItems = selectedProducts => {
        return validateSelectedItems(selectedProducts, {
            le: this.le
        });
    };

    getProductDealerCode = product => {
        return getProductDealerCode(product);
    };

    hasMixedDealerCodes = selectedProducts => {
        return hasMixedDealerCodes(selectedProducts);
    };

    getSelectedDealerCode = () => {
        const selectedProducts =
            this.state.selectedProducts || [];

        return selectedProducts.length
            ? this.getProductDealerCode(selectedProducts[0])
            : "";
    };

    //#endregion

    //#region Handle Submit

    handleSubmit = async () => {

        if (!this.state.warehouseConfigReady) {
            return;
        }

        try {
            const errors = this.validateForm();

            const hasErrors =
                errors.global.length > 0 ||
                Object.keys(errors.quantity).length > 0 ||
                Object.keys(errors.recipient).length > 0 ||
                Object.keys(errors.orderInfo).length > 0;

            if (hasErrors) {
                this.setState({ errors }, () => {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                });

                return;
            }

            const sendOrderData = buildOrderPayload({
                state: this.state,
                userContext: this.uc,
                language: Languages.selectedLanguage,
                logic: this.orderLogic,
                profile: this.profile
            });

            this.props.loaderShow(0);
            const response = await SendOrder(this.uc.jwtToken, sendOrderData);
            this.props.loaderHide();
            if (response?.error) {
                this.props.popupErrorMessage(response.error.status === 409
                        ? this.le.errors.duplicateOrderReference
                        : this.le.errors.genericError);

                return;
            }

            const returnedOrderNumber = response?.result?.order?.sendOrderV2Result?.data?.[0]?.number;

            if (!returnedOrderNumber) {
                this.props.popupErrorMessage(this.le.errors.genericError);

                return;
            }

            const returnOrderNumber = this.formatReturnedOrderNumber(returnedOrderNumber);

            this.setState((prevState) => ({
                entries: [],
                filters: this.createInitialFilters(),
                products: [],
                totals: [],
                selectedProducts: [],
                tableInstanceId: prevState.tableInstanceId + 1,
                showSuccessPopup: true,
                successOrderNumber: returnOrderNumber,
                orderType: this.le.orderTypes.value[0],
                customerPickup: false,
                data: {
                    ...prevState.data,
                    orderInfo: {
                        orderReference: "",
                        notes: ""
                    },
                    recipient: {
                        selectedDealer: "",
                        recipientSource: "manual",
                        recipientSourceId: "",

                        name: "",
                        surname: "",
                        recipientCode: "",
                        country: "ITALIA",
                        province: "",
                        city: "",
                        zip: "",
                        address: "",
                        email: "",
                        mobile: ""
                    },
                },
                errors: {
                    global: [],
                    quantity: {},
                    recipient: {},
                    orderInfo: {}
                },
            }), () => {
                //this.handleFilterSearch();
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            });
        } catch (error) {
            this.props.loaderHide();

            console.error(
                "Errore durante l'invio dell'ordine:",
                error
            );

            this.props.popupErrorMessage(
                this.le.errors.genericError
            );
        }
    };

    //#endregion

    //#region Component Functions

    async componentDidMount() {
        this._isMounted = true;

        try {
            const loaded = await this.loadWarehouseConfiguration();

            if (!loaded || !this._isMounted) {
                return;
            }

        } catch (error) {
            if (this._isMounted) {
                this.setState({
                    warehouseConfigError: error.message
                });

                this.props.popupErrorMessage(error.message);
            }

            return;
        }

        if (this.uiProfile.canLoadDealers) {
            this.getDealersData();
        }

        this.loadRecipientAddressesData();

        loadAutocompleteCountries(this.uc.jwtToken,
            countries => {
                if (!this._isMounted) {
                    return;
                }

                this.setState(
                    {
                        countries: countries || []
                    },
                    () => {
                        const recipientCountryCode =
                            this.getCountryCodeByName("ITALIA");

                        this.setState({
                            recipientCountryCode
                        });
                    }
                );
            },
            error => {
                console.error(
                    "Errore durante il caricamento dei paesi",
                    error
                );
            },
            this
        );
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    //componentDidUpdate(prevProps) {
    //    const prevOrderId = prevProps.location.search;
    //    const currentOrderId = this.props.location.search;

    //    if ((prevOrderId && !currentOrderId)) {
    //       // const resetReturnedOrder = this.resetReturnedOrdersData();
    //        //this.setState({
    //           // data: resetReturnedOrder
    //        //});
    //    }
    //}

    //#endregion

    //#region Dealers

    getDealersData = async () => {
        try {
            const getDataDealer = {
                Data: {
                    DealerCode: this.uiProfile.canChooseDealer
                        ? null
                        : this.uc.dealerCode,
                    Active: true,
                    OnlyNotSubscribed: false
                }
            };

            const response = await getDealers(this.uc.jwtToken, getDataDealer);

            if (!this._isMounted) {
                return;
            }

            const dealerResponse =
                response?.result?.dealers?.getDealerResult?.data || [];

            const dealers =
                this.buildEntriesDealer(dealerResponse);

            this.setState(prevState => ({
                dealers,
                recipientOptions: this.buildRecipientOptions(
                    dealers,
                    prevState.recipientWarehouses
                )
            }));

        } catch (error) {
            console.error("Error when it try to load dealers", error);

            if (!this._isMounted) {
                return;
            }

            this.setState(prevState => ({
                dealers: [],
                recipientOptions: this.buildRecipientOptions(
                    [],
                    prevState.recipientWarehouses
                )
            }));
        }
    };

    buildEntriesDealer = (dealers) => {
        let entries = [];
        if (dealers.length <= 0) {
            return []
        }
        for (let i = 0; i < dealers.length; i++) {
            let dealer = dealers[i];
            let entry = {
                dealerCode: dealer.dealerCode ?? "",
                piva: dealer.piva ?? "",
                codiceFiscale: dealer.codiceFiscale ?? "",
                customerName: dealer.customerName ?? "",
                alternateName: dealer.alternateName ?? "",
                postalCode: dealer.postalCode ?? "",
                city: dealer.city ?? "",
                province: dealer.state ?? "",
                address1: dealer.address1 ?? "",
                title: dealer.title ?? "",
                job: dealer.job ?? "",
                firstName: dealer.firstName ?? "",
                lastName: dealer.lastName ?? "",
                emailAddress: dealer.emailAddress ?? "",
                pec: dealer.pec ?? "",
                phone: dealer.phone ?? "",
                ext: dealer.ext ?? "",
                fax: dealer.fax ?? "",
                mobile: dealer.mobile ?? "",
            };
            entries.push(entry);
        }

        return entries;
    }

    setRecipientFromDealer = (dealer, dealers = this.state.dealers) => {
        if (!this._isMounted || !dealer) {
            return;
        }
        const recipient = {
            selectedDealer: `dealer:${dealer.dealerCode}`,
            recipientSource: "dealer",
            recipientSourceId: dealer.dealerCode || "",
            recipientCode: dealer.dealerCode || "",
            name: dealer.customerName || "",
            address: dealer.address1 || "",
            city: dealer.city || "",
            province: dealer.province || "",
            zip: dealer.postalCode || "",
            email: dealer.emailAddress || "",
            country: ""
        };

        const newData = {
            ...this.state.data,
            recipient: {
                ...this.state.data.recipient,
                ...recipient
            }
        };

        const recipientItems = this.inputBoxes[0].columns[1].items;

        recipientItems.forEach(item => {
            if (recipient.hasOwnProperty(item.id)) {
                item.value = recipient[item.id] != null
                    ? recipient[item.id]
                    : "";
            }
        });

        if (!this._isMounted) {
            return;
        }

        this.setState({
            dealers: dealers,
            data: newData
        });
    };



    addressChange(ev, who, value) {
        const path = Array.isArray(who) ? who : [];

        const columnIndex = path[path.length - 2];
        const itemIndex = path[path.length - 1];

        if (
            !Number.isInteger(columnIndex) ||
            !Number.isInteger(itemIndex)
        ) {
            console.error("Percorso del campo non valido:", who);
            return;
        }

        const sections = this.inputBoxes[0];

        const selectedColumn = sections?.columns?.[columnIndex];

        const visibleItems =
            selectedColumn?.items?.filter(
                item => item.type !== "hidden"
            ) || [];

        const selectedItem = visibleItems[itemIndex];

        if (!selectedColumn || !selectedItem) {
            console.error("Colonna o campo non trovato:", {
                who,
                columnIndex,
                itemIndex
            });
            return;
        }

        const column = selectedColumn.id;
        const field = selectedItem.id;

        if (column === "sender") {
            if (field === "warehouse") {
                this.handleWarehouseChange(value);
            }
            return;
        }

        const newData = {
            sender: {},
            recipient: {},
            ...JSON.parse(JSON.stringify(this.state.data))
        };

        newData[column] = {
            ...newData[column],
            [field]: value
        };

        const updateInputValues = (columnName, currentColumnIndex) => {
            const items = sections.columns[currentColumnIndex]?.items || [];

            items.forEach(item => {
                if (
                    newData[columnName] &&
                    Object.prototype.hasOwnProperty.call(newData[columnName], item.id)
                ) {
                    item.value =
                        newData[columnName][item.id] != null
                            ? newData[columnName][item.id]
                            : "";
                }
            });
        };

        if (
            field === "selectedDealer" &&
            column === "recipient"
        ) {
            if (!value) {
                newData.recipient = {
                    ...newData.recipient,
                    selectedDealer: "",
                    recipientSource: "manual",
                    recipientSourceId: "",
                    name: "",
                    surname: "",
                    recipientCode: "",
                    address: "",
                    city: "",
                    province: "",
                    zip: "",
                    email: "",
                    country: "ITALIA",
                    mobile: ""
                };

                updateInputValues("recipient", columnIndex);

                this.setState(
                    {
                        recipientCountryCode: this.getCountryCodeByName("ITALIA"),
                        suggestedRecipientCities: []
                    },
                    () => {
                        this.updateRecipientData(newData);
                    }
                );

                return;
            }

            if (
                typeof value === "string" &&
                value.startsWith("dealer:")
            ) {
                const dealerCode = value.replace("dealer:", "");

                const selectedDealer = this.state.dealers.find(
                    dealer =>
                        String(dealer.dealerCode) ===
                        String(dealerCode)
                );

                if (!selectedDealer) {
                    return;
                }

                newData.recipient = {
                    ...newData.recipient,
                    selectedDealer: value,
                    recipientSource: "dealer",
                    recipientSourceId: dealerCode,
                    recipientCode: selectedDealer.dealerCode || "",
                    name: selectedDealer.customerName || "",
                    surname: "",
                    address: selectedDealer.address1 || "",
                    city: selectedDealer.city || "",
                    province: selectedDealer.province || "",
                    zip: selectedDealer.postalCode || "",
                    email: selectedDealer.emailAddress || "",
                    country: "ITALIA",
                    mobile: selectedDealer.mobile || selectedDealer.phone || ""
                };

                updateInputValues("recipient", columnIndex);

                this.setState(
                    {
                        recipientCountryCode: this.getCountryCodeByName("ITALIA"),
                        suggestedRecipientCities: []
                    },
                    () => {
                        this.updateRecipientData(newData);
                    }
                );

                return;
            }

            if (
                typeof value === "string" &&
                value.startsWith("address:")
            ) {
                const addressId = value.replace("address:", "");

                const selectedAddress = this.state.recipientWarehouses.find(
                    address =>
                        String(address.id) ===
                        String(addressId)
                );

                if (!selectedAddress) {
                    return;
                }

                const completeAddress = [
                    selectedAddress.address,
                    selectedAddress.houseNo
                ]
                    .map(item => String(item || "").trim())
                    .filter(Boolean)
                    .join(" ");

                const country = selectedAddress.nation
                    ? String(selectedAddress.nation).toUpperCase()
                    : "ITALIA";

                newData.recipient = {
                    ...newData.recipient,
                    selectedDealer: value,
                    recipientSource: "addressBook",
                    recipientSourceId: addressId,
                    recipientCode: selectedAddress.recipientCode || selectedAddress.RecipientCode || "",
                    name: selectedAddress.name || "",
                    surname: selectedAddress.surname || "",
                    address: completeAddress,
                    city: selectedAddress.city || "",
                    province: selectedAddress.province || "",
                    zip: selectedAddress.zip || "",
                    email: selectedAddress.email || "",
                    country,
                    mobile: selectedAddress.mobile || selectedAddress.phone || ""
                };

                updateInputValues("recipient", columnIndex);

                this.setState(
                    {
                        recipientCountryCode: this.getCountryCodeByName(country),
                        suggestedRecipientCities: []
                    },
                    () => {
                        this.updateRecipientData(newData);
                    }
                );

                return;
            }
        }

        updateInputValues(column, columnIndex);

        if (column === "recipient") {
            this.setState(prevState => {
                const recipientErrors = {
                    ...prevState.errors.recipient
                };

                delete recipientErrors[field];

                return {
                    data: newData,
                    errors: {
                        ...prevState.errors,
                        recipient: recipientErrors
                    }
                };
            });
        } else {
            this.setState({
                data: newData
            });
        }
    }

    //#endregion

    //#region Handle autocoplete functions to Country and City

    getCountryCodeByName = countryName => {
        const normalizedCountryName =
            String(countryName || "")
                .trim()
                .toUpperCase();

        const selectedCountry =
            (this.state.countries || []).find(country => {
                const name =
                    country.name ??
                    country.countryName ??
                    country.description ??
                    country.text ??
                    country.label ??
                    "";

                return String(name)
                    .trim()
                    .toUpperCase() === normalizedCountryName;
            });

        return (
            selectedCountry?.countryCode ??
            selectedCountry?.code ??
            selectedCountry?.value ??
            ""
        );
    };

    onRecipientCountryChange = (who, value, countryCode) => {
        this.setState(prevState => {
            const recipientErrors = {
                ...prevState.errors.recipient
            };

            delete recipientErrors.country;
            delete recipientErrors.city;
            delete recipientErrors.province;
            delete recipientErrors.zip;

            return {
                recipientCountryCode:
                    countryCode || "",

                suggestedRecipientCities: [],

                data: {
                    ...prevState.data,

                    recipient: {
                        ...prevState.data.recipient,

                        country:
                            String(value || "").trim(),

                        city: "",
                        province: "",
                        zip: ""
                    }
                },

                errors: {
                    ...prevState.errors,
                    recipient: recipientErrors
                }
            };
        });
    };

    onRecipientCityChange = (who, value) => {
        const cityValue =
            String(value || "");

        this.setState(prevState => ({
            data: {
                ...prevState.data,

                recipient: {
                    ...prevState.data.recipient,
                    city: cityValue,
                    province: "",
                    zip: ""
                }
            }
        }));

        if (cityValue.trim().length < 2) {
            this.setState({
                suggestedRecipientCities: []
            });

            return;
        }

        const countryCode =
            this.state.recipientCountryCode ||
            this.getCountryCodeByName(
                this.state.data.recipient.country
            );

        if (!countryCode) {
            this.setState({
                suggestedRecipientCities: []
            });

            return;
        }

        autoCompleteForeignCitiesForCountry(
            this.uc.jwtToken,
            cityValue,
            countryCode,
            cities => {
                if (!this._isMounted) {
                    return;
                }

                this.setState({
                    suggestedRecipientCities:
                        cities || []
                });
            }
        );
    };

    onRecipientCitySelected = (who, selectedCity) => {
        if (!selectedCity) {
            return;
        }

        const city =
            selectedCity.city ??
            selectedCity.cityName ??
            selectedCity.name ??
            selectedCity.labelShort ??
            selectedCity.label ??
            "";

        const province =
            selectedCity.province ??
            selectedCity.provinceCode ??
            selectedCity.state ??
            selectedCity.region ??
            "";

        const zip =
            selectedCity.zip ??
            selectedCity.zipCode ??
            selectedCity.postalCode ??
            selectedCity.value ??
            "";

        this.setState(prevState => {
            const recipientErrors = {
                ...prevState.errors.recipient
            };

            delete recipientErrors.city;
            delete recipientErrors.province;
            delete recipientErrors.zip;

            return {
                suggestedRecipientCities: [],

                data: {
                    ...prevState.data,

                    recipient: {
                        ...prevState.data.recipient,
                        city,
                        province,
                        zip
                    }
                },

                errors: {
                    ...prevState.errors,
                    recipient: recipientErrors
                }
            };
        });
    };

    //#endregion

    //#region set Sender and Recipient
    findSenderWareHouseById(id) {
        let wareh = this.state.senderWarehouses.find(a => a.id == id);
        if (wareh == undefined) {
            return null;
        }
        return wareh;
    }

    setSender(sender, warehouseId) {
        const warehouse = this.findSenderWareHouseById(warehouseId);

        return {
            ...sender,
            name: warehouse?.name || "",
            city: warehouse?.city || "",
            province: warehouse?.province || "",
            country: warehouse?.country || ""
        };
    }

    //setRecipient(recipient, warehouseId) {
    //    let wareh = this.findRecipientWareHouseById(warehouseId);
    //    if (wareh != null) {
    //        recipient.name = wareh.name;
    //        recipient.address = wareh.address;
    //        recipient.city = wareh.city;
    //        recipient.country = wareh.nation.toUpperCase();
    //        recipient.province = wareh.province;
    //        recipient.zip = wareh.zip;
    //        recipient.email = wareh.email;
    //    } else {
    //        recipient.name = '';
    //        recipient.address = '';
    //        recipient.country = 'ITALIA';
    //        recipient.city = '';
    //        recipient.province = '';
    //        recipient.zip = '';
    //        recipient.email = '';
    //    }
    //    return recipient;
    //}
    //#endregion

    // #endregion

    //#region Stock Functions

    toggleAdvancedFilters = () => {
        this.setState(prevState => ({
            advancedOpen: !prevState.advancedOpen
        }));
    };

    parseSKUFilter(skuValue) {
        return (skuValue || "").split(";").map(sku => sku.trim()).filter(Boolean);
    }

    getDataStock = async (filters) => {

        const requestVersion = ++this._stockRequestVersion;

        if (this._isMounted) {
            this.setState({ loading: true })
        }

        const { pageNumber, pageSize, sortField, sortDirection } = this.state;

        try {
            const skuList = this.parseSKUFilter(filters.SKU);
            const dealerCode =
                this.uc.userRole === Roles.WAREHOUSEUSER
                    ? this.uc.dealerCode
                    : (filters.dealerCode || null);
            const getStockData = {
                Data: {
                    SKU: skuList,
                    dealerCode: dealerCode,
                    state: "BUONO",
                    description: filters.description || "",
                    //BCNU: filters.BCNU || null,
                    DELN: filters.DELN || null,
                    SORD: filters.SORD || null,
                    SCNU: filters.SCNU || null,
                    SCNA: filters.SCNA || null,
                    CNUM: filters.CNUM || null,
                    //SSCC: filters.SSCC || null,
                    lot: filters.serialCode || null,
                    language: Languages.selectedLanguage.toUpperCase(),
                    PageNumber: pageNumber,
                    PageSize: pageSize,
                    SortField: sortField,
                    SortDirection: sortDirection
                }
            };

            const quantityComparison = filters.QuantityFilter?.Comparison;
            const quantityValue = filters.QuantityFilter?.Value;

            const hasQuantityComparison =
                quantityComparison !== null &&
                quantityComparison !== undefined &&
                quantityComparison !== "";

            const hasQuantityValue =
                quantityValue !== null &&
                quantityValue !== undefined &&
                quantityValue !== "";

            if (hasQuantityComparison && hasQuantityValue) {
                const parsedQuantityValue = parseInt(quantityValue, 10);

                getStockData.Data.QuantityFilter = {
                    Comparison: quantityComparison,
                    Value: Number.isNaN(parsedQuantityValue)
                        ? null
                        : parsedQuantityValue
                };
            } else {
                getStockData.Data.QuantityFilter = null;
            }


            this.props.loaderShow(0);

            getStockData.Data = this.profile.customizeStockRequest(getStockData.Data, filters);


            const response = await getStockAPI(this.uc.jwtToken, getStockData);

            if (!this._isMounted || requestVersion !== this._stockRequestVersion) {
                return;
            }

            if (!response) {
                throw new Error("Risposta stock non disponibile.");
            }

            if (response.error == null) {
                this.props.loaderHide();
                const stock = response?.result?.stock;
                const products = stock?.data ?? [];
                let entries = this.buildEntriesStock(products);

                let totals = [{ name: 'stock', val: response.result.stock.data.length }];

                if (this._isMounted) {
                    this.setState({
                        entries: entries,
                        products: products,
                        totals: totals,
                        loading: false,
                        pageNumber: stock?.pageNumber ?? pageNumber,
                        pageSize: stock?.pageSize ?? pageSize,
                        totalItems: stock?.totalItems ?? products.length,
                        totalPages: stock?.totalPages ?? 1
                    });
                }

            } else {
                this.props.loaderHide();
                this.props.popupErrorMessage(response.error.message);
            }

        }
        catch (error) {
            if (!this._isMounted || requestVersion !== this._stockRequestVersion) {
                return;
            }

            this.props.loaderHide();

            this.setState({
                loading: false
            });

            this.props.popupErrorMessage(error.message || this.le.errors.genericError);
        }
    }

    handleClearFilters = () => {
        const filters = this.createInitialFilters();

        this.setState(
            {
                filters,
                pageNumber: 1
            },
            () => {
                this.getDataStock(filters);
            }
        );
    };

    getStockEntryId = (product) => {
        if (product.id !== null && product.id !== undefined) {
            return String(product.id);
        }

        return [
            product.dealerCode || "",
            product.sku || "",
            product.lot || "",
            product.sord || "",
            product.sscc || "",
            product.ownerCode || ""
        ].join("|");
    };

    buildEntriesStock = (products) => {
        let entries = [];

        for (let i = 0; i < products.length; i++) {
            let product = products[i];

            let entry = {
                //#region standard-dealer
                id: this.getStockEntryId(product),
                SKU: product.sku,
                description: product.description,
                avaibleQuantity: product.availableQuantity?.toString() || "0",
                reservedQuantity: product.reservedQuantity?.toString() || "0",
                serialCode: product.lot ?? "",

                dealerName: product.dealerName || "",
                dealerCode: product.dealerCode || "",
                SORD: product.sord ?? "",
                SendLabel: product.sendLabel,
                ownerCode: product.ownerCode ?? "",
                BCNU: product.bcnu ?? "",
                SCNU: product.scnu ?? "",
                CNUM: product.cnum ?? "",
                SSCC: product.sscc ?? "",

                weight: product.weight ?? "0",
                volume: product.volume ?? "0",
                unitPrice: product.unitPrice ?? "0",
                originalPrice: product.originalPrice ?? "0",
                discount: product.discount ?? "0",
                voucher: product.voucher ?? "0",
                annotations: product.annotations ?? "",
                //#endregion

                //#region NPO
                amount: product.amnt ?? "",
                //#endregion
            };

            entries.push(entry);
        }

        return entries;
    };

    handleFilterSearch = (ev) => {
        if (ev) {
            ev.preventDefault();
        }

        this.setState(
            { pageNumber: 1 },
            () => this.getDataStock(this.state.filters)
        );
    }

    handleFilterChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "QuantityFilter.Comparison" || name === "QuantityFilter.Value") {
            const field = name.split(".")[1];

            return this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    QuantityFilter: {
                        ...prevState.filters.QuantityFilter,
                        [field]: value
                    }
                }
            }));
        }

        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [name]: type === "checkbox" ? checked : value
            }
        }));
    };

    handlePageChange = (pageNumber) => {
        this.setState(
            { pageNumber },
            () => this.getDataStock(this.state.filters)
        );
    }

    handlePageSizeChange = (pageSize) => {
        this.setState(
            {
                pageSize,
                pageNumber: 1
            },
            () => this.getDataStock(this.state.filters)
        );
    }

    //#endregion

    //#region Render Error

    renderOrderInfoErrors() {
        const orderInfoErrors =
            Object.entries(
                this.state.errors.orderInfo || {}
            );

        if (!orderInfoErrors.length) {
            return null;
        }

        return (
            <div className="page-error-box order-info-error-box">
                <ul>
                    {orderInfoErrors.map(([field, message]) => (
                        <li key={field}>{message}</li>
                    ))}
                </ul>
            </div>
        );
    }

    renderRecipientErrors() {
        const recipientErrors = this.state.errors.recipient || {};

        const errorEntries = Object.entries(recipientErrors);

        if (!errorEntries.length) {
            return null;
        }

        return (
            <div className="page-error-box recipient-error-box">
                <div className="error-box-title">
                    {this.le.errors.RecipientDataError}
                </div>

                <ul>
                    {errorEntries.map(([field, message]) => (
                        <li key={field}>
                            {message}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    renderError() {
        const { errors } = this.state;
        const globalErrors = errors.global || [];
        const quantityErrors = Object.entries(errors.quantity || {}).map(([id, message]) => {
            const product = this.state.selectedProducts.find(product => product.id === id);
            const sku = product?.SKU || id;

            return `SKU ${sku} - ${message}`;
        });
        const allErrors = [...globalErrors, ...quantityErrors];

        if (!allErrors.length) return null;

        return (
            <div className="page-error-box">
                <ul>
                    {allErrors.map((error, index) => (
                        <li key={index}>{error}</li>
                    ))}
                </ul>
            </div>
        );
    }

    //#endregion

    render() {

        if (!this.state.warehouseConfigReady) {
            return (
                <div className="page-order-creation">
                    {this.state.warehouseConfigError || "Caricamento configurazione warehouse..."}
                </div>
            );
        }

        //#region Data Structures

        const isProvinceRequired = this.profile.isProvinceRequired(this.state.data.recipient);

        const sections =
            this.inputBoxes.map(section => ({
                ...section,

                columns:
                    section.columns.map(column => {
                        const columnData =
                            this.state.data[column.id] || {};

                        if (column.id === "sender") {
                            const warehouses = this.state.senderWarehouses;
                            const selectedWarehouse = this.getSelectedWarehouse();
                            const canChooseWarehouse = warehouses.length > 1;

                            return {
                                ...column,

                                items: column.items.map(item => {
                                    if (item.id === "warehouse") {
                                        return {
                                            ...item,

                                            type: canChooseWarehouse
                                                ? "select"
                                                : "text",

                                            disabled: !canChooseWarehouse,

                                            value: canChooseWarehouse
                                                ? this.state.selectedWarehouseId
                                                : selectedWarehouse?.name || "",

                                            options: [
                                                {
                                                    text: "---------",
                                                    value: ""
                                                },

                                                ...warehouses.map(warehouse => ({
                                                    text: `${warehouse.name} — ${warehouse.city}`,
                                                    value: warehouse.id
                                                }))
                                            ]
                                        };
                                    }

                                    return {
                                        ...item,
                                        disabled: true,
                                        value: selectedWarehouse?.[item.id] || ""
                                    };
                                })
                            };
                        }

                        return {
                            ...column,

                            items: column.items
                                .filter(
                                    item =>
                                        item.type !== "hidden"
                                )
                                .map(item => {
                                    let options = item.options;

                                    if (column.id === "recipient" && item.id === "selectedDealer") {
                                        options = this.state.recipientOptions;
                                    }

                                    if (column.id === "recipient" && item.id === "country") {
                                        options = this.state.countries;
                                    }

                                    if (column.id === "recipient" && item.id === "city"
                                    ) {
                                        options = this.state.suggestedRecipientCities;
                                    }

                                    return {
                                        ...item,

                                        mandatory:
                                            column.id === "recipient" && item.id === "province"
                                                ? isProvinceRequired
                                                : item.mandatory,

                                        value:
                                            Object.prototype
                                                .hasOwnProperty.call(
                                                    columnData,
                                                    item.id
                                                )
                                                ? columnData[item.id] ?? ""
                                                : item.value,

                                        options,

                                        disabled:
                                            column.id === "recipient"
                                                ? this.isRecipientItemDisabled(
                                                    item,
                                                    columnData
                                                )
                                                : item.disabled
                                    };
                                })
                        };
                    })
            }));

        const addressSection = {
            ...sections[0],
            columns: sections[0].columns.filter(column =>
                column.id === "sender" || column.id === "recipient"
            )
        };

        const reactAddressSection = (
            <WarehouseAddresses
                config={this.profile.orderCreation.components.addresses}
                key="address-section"
                shouldShowTriangolationSection={true}
                section={addressSection.id}
                data={addressSection}
                splitColumns={true}
                onChange={this.addressChange}
                onAutocompleteCountryChange={this.onRecipientCountryChange}
                onAutocompleteChange={this.onRecipientCityChange}
                onAutocompleteSelected={this.onRecipientCitySelected}
            />
        );

        //#endregion Data Structures

        //#region pageFilter

        const advancedFilterNames = this.profile.customizeAdvancedFilterNames([...standardAdvancedFilterNames]);

        //#endregion

        const selectedProductDealerCode = this.getSelectedDealerCode();

        return <div className="page-order-creation">
            <PageTitle icon="../images/mainMenu/Orders.png" title={Languages.getSection('Main').menuLabels.ordersCreateSingle}></PageTitle>
            <div className="page-content">

                <div className="single-order-container">

                    {this.renderOrderInfoErrors()}

                    <WarehouseOrderInfo
                        config={this.profile.orderCreation.components.orderInfo}
                        data={this.orderInfoConfig}
                        values={this.state.data.orderInfo}
                        errors={this.state.errors.orderInfo}
                        onChange={this.handleOrderInfoChange}
                    />

                    <div className="order-order-config">
                        <div className="order-subtitle">{this.le.configuration}</div>

                        <WarehouseFilters
                            config={this.profile.orderCreation.components.filters}
                            fields={this.configs.filters}
                            values={this.state.filters}
                            labels={this.le.stock.filters.items}
                            onChange={this.handleFilterChange}
                            onSearch={this.handleFilterSearch}
                            onClear={this.handleClearFilters}
                            advancedKeys={advancedFilterNames}
                            advancedOpen={this.state.advancedOpen}
                            onAdvancedToggle={this.toggleAdvancedFilters}
                        />

                        {this.renderError()}

                        <div className="warehouse-table-safe-area">
                            <WarehouseStockSelection
                                key={this.state.tableInstanceId}
                                config={this.profile.orderCreation.components.stockTable}
                                headers={this.header}
                                items={this.state.entries}
                                rowKey="id"
                                onSelectionChange={this.handleSelectionChange}
                                errors={this.state.errors}
                                selectedDealerCode={selectedProductDealerCode}
                                differentDealerTooltip={
                                    this.le.errors.differentDealerSelectionTooltip
                                }
                                serverSidePagination={true}
                                currentPage={this.state.pageNumber}
                                itemsPerPage={this.state.pageSize}
                                totalItems={this.state.totalItems}
                                totalPages={this.state.totalPages}
                                onPageChange={this.handlePageChange}
                                onItemsPerPageChange={this.handlePageSizeChange}
                            />
                        </div>

                    </div>

                    <WarehouseOrderOptions
                        config={this.profile.orderCreation.components.orderOptions}
                        orderTypes={this.le.orderTypes}
                        orderType={this.state.orderType}
                        customerPickup={this.state.customerPickup}
                        onOrderTypeChange={this.handleRadioChange}
                        onCustomerPickupChange={this.handleCustomerPickupChange}
                    />

                    {this.renderRecipientErrors()}

                    {reactAddressSection}

                    <UIButtonPad className="order-button-pad right" align="right">
                        <UIButton
                            type="button"
                            text={this.le.button}
                            onClick={this.handleSubmit}
                            className="slim confirm" />
                    </UIButtonPad>
                </div>
            </div>
            <UISuccessPopup
                visible={this.state.showSuccessPopup}
                title={this.le.successPopup.title}
                message={this.le.successPopup.message}
                highlightedValue={this.state.successOrderNumber}
                iconClassName="fa-thin fa-badge-check"
                messageSuffix={this.le.successPopup.messageSuffix}
                autoClose={true}
                duration={4000}
                showProgress={true}
                onClose={() => this.setState({ showSuccessPopup: false })}
            />
        </div>;
    }
}
